<template>
    <v-sheet elevation="1">
        <v-toolbar
            flat
            rounded
            color="secondary">
            <v-toolbar-title>{{$t("FAILURES")}}</v-toolbar-title>
        </v-toolbar>
        <div class="pa-4">
            <FailureList/>
        </div>
    </v-sheet>
</template>

<script>
import FailureList from './../components/FailureList';

export default {
    name: "FailureMaster",
    components:{ FailureList }
}
</script>

<style>

</style>